<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: 'layout-page',
}
</script>
